// LumiCap — shared behaviour for all lc-* sections. Vanilla JS, no dependencies.
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initAccordions();
  initCountUp();
  initProductGallery();
  initQuantity();
  initStickyAddToCart();
});

function initReveal() {
  var els = document.querySelectorAll('.lc-reveal, .lc-reveal-stagger');
  if (!els.length) return;
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('lc-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('lc-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function toggleAccordionItem(item, questionSelector, answerSelector) {
  var isOpen = item.classList.contains('lc-open');
  var answer = item.querySelector(answerSelector);
  if (isOpen) {
    item.classList.remove('lc-open');
    answer.style.maxHeight = 0;
  } else {
    item.classList.add('lc-open');
    answer.style.maxHeight = answer.scrollHeight + 'px';
  }
}

function initAccordions() {
  document.querySelectorAll('.lc-faq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.lc-faq-item');
      if (!item) return;
      var group = item.closest('.lc-faq-list');
      if (group) {
        group.querySelectorAll('.lc-faq-item.lc-open').forEach(function (openItem) {
          if (openItem !== item) toggleAccordionItem(openItem, '.lc-faq-q', '.lc-faq-a');
        });
      }
      toggleAccordionItem(item, '.lc-faq-q', '.lc-faq-a');
    });
  });

  document.querySelectorAll('.lc-accordion-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.lc-accordion-item');
      if (item) toggleAccordionItem(item, '.lc-accordion-q', '.lc-accordion-a');
    });
  });
}

function initCountUp() {
  var els = document.querySelectorAll('.lc-countup');
  if (!els.length || !('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        observer.unobserve(el);
        var target = parseFloat(el.dataset.target || el.textContent) || 0;
        var duration = 1200;
        var start = null;
        var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (prefersReduced) {
          el.textContent = target;
          return;
        }
        function step(ts) {
          if (start === null) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = Math.round(target * eased);
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    },
    { threshold: 0.6 }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function initProductGallery() {
  var root = document.querySelector('[data-lc-gallery]');
  if (!root) return;
  var frame = root.querySelector('[data-lc-gallery-frame]');
  var track = root.querySelector('[data-lc-gallery-track]');
  var slides = Array.prototype.slice.call(root.querySelectorAll('[data-lc-gallery-slide]'));
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-lc-gallery-thumb]'));
  var dots = Array.prototype.slice.call(root.querySelectorAll('[data-lc-gallery-dots] .lc-gallery-dot'));
  var prevBtn = root.querySelector('[data-lc-gallery-prev]');
  var nextBtn = root.querySelector('[data-lc-gallery-next]');
  if (!track || !slides.length) return;

  var current = 0;
  var settling = false;

  function setActive(index) {
    current = index;
    thumbs.forEach(function (t) { t.classList.remove('lc-active'); });
    if (thumbs[index]) thumbs[index].classList.add('lc-active');
    dots.forEach(function (d) { d.classList.remove('lc-active'); });
    if (dots[index]) dots[index].classList.add('lc-active');
  }

  function goTo(index) {
    if (index < 0) index = slides.length - 1;
    if (index >= slides.length) index = 0;
    settling = true;
    track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
    setActive(index);
    window.setTimeout(function () { settling = false; }, 450);
  }

  thumbs.forEach(function (thumb, i) {
    thumb.addEventListener('click', function () { goTo(i); });
  });
  prevBtn && prevBtn.addEventListener('click', function () { goTo(current - 1); });
  nextBtn && nextBtn.addEventListener('click', function () { goTo(current + 1); });

  if (frame) {
    frame.setAttribute('tabindex', '0');
    frame.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { goTo(current - 1); e.preventDefault(); }
      if (e.key === 'ArrowRight') { goTo(current + 1); e.preventDefault(); }
    });
  }

  // The track is a plain native-scroll flex row (scroll-snap): real touch
  // swipe, mouse wheel and trackpad gestures all just work, on every device,
  // without any custom drag code — and vertical page scroll is never
  // affected because the track has no vertical overflow to capture.
  var scrollTimer = null;
  track.addEventListener('scroll', function () {
    if (settling) return;
    window.clearTimeout(scrollTimer);
    scrollTimer = window.setTimeout(function () {
      var width = track.clientWidth || 1;
      var index = Math.round(track.scrollLeft / width);
      if (index !== current) setActive(index);
    }, 100);
  });

  window.addEventListener('resize', function () {
    track.scrollTo({ left: slides[current] ? slides[current].offsetLeft : 0, behavior: 'auto' });
  });

  // Desktop bonus: click-and-drag with the mouse also pans the track.
  // Touch is left entirely to the browser's own native scrolling above.
  var dragStartX = 0, dragStartScroll = 0, isMouseDragging = false;
  track.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse') return;
    isMouseDragging = true;
    dragStartX = e.clientX;
    dragStartScroll = track.scrollLeft;
    track.classList.add('lc-grabbing');
  });
  track.addEventListener('pointermove', function (e) {
    if (!isMouseDragging) return;
    track.scrollLeft = dragStartScroll - (e.clientX - dragStartX);
  });
  function stopMouseDrag() {
    if (!isMouseDragging) return;
    isMouseDragging = false;
    track.classList.remove('lc-grabbing');
    var width = track.clientWidth || 1;
    goTo(Math.round(track.scrollLeft / width));
  }
  track.addEventListener('pointerup', stopMouseDrag);
  track.addEventListener('pointerleave', stopMouseDrag);
}

function initQuantity() {
  document.querySelectorAll('[data-lc-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var minus = wrap.querySelector('[data-lc-qty-minus]');
    var plus = wrap.querySelector('[data-lc-qty-plus]');
    if (!input) return;
    minus && minus.addEventListener('click', function () {
      var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    plus && plus.addEventListener('click', function () {
      var v = (parseInt(input.value, 10) || 1) + 1;
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
}

function initStickyAddToCart() {
  var sticky = document.querySelector('[data-lc-sticky-atc]');
  var mainForm = document.querySelector('[data-lc-main-atc]');
  if (!sticky || !mainForm || !('IntersectionObserver' in window)) return;

  function updateBodySpace(show) {
    document.body.style.paddingBottom = show ? sticky.offsetHeight + 'px' : '';
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('lc-show', show);
        updateBodySpace(show);
      });
    },
    { threshold: 0 }
  );
  observer.observe(mainForm);

  window.addEventListener('resize', function () {
    if (sticky.classList.contains('lc-show')) updateBodySpace(true);
  });

  var stickyBtn = sticky.querySelector('button[type="submit"], button[data-lc-sticky-submit]');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var realSubmit = mainForm.querySelector('button[type="submit"]');
      if (realSubmit) realSubmit.click();
    });
  }
}
